import React from 'react';
import { Navigate, Route, Routes } from 'react-router-dom';
import { ROUTES } from '../../../constants/routes';
import AnalyticsHomePage from './AnalyticsHomePage.jsx';
import ReportBuilderPage from './ReportBuilderPage.jsx';
import ReportViewerPage from './ReportViewerPage.jsx';
// import TemplateInsightsPage from './TemplateInsightsPage.jsx';

export default function AnalyticsRoutes() {
  return (
    <Routes>
      <Route index element={<AnalyticsHomePage />} />
      <Route path="builder/:reportId" element={<ReportBuilderPage />} />
      <Route path="builder" element={<ReportBuilderPage />} />
      {/* <Route path="template-insights/:templateId" element={<TemplateInsightsPage />} /> */}
      {/* <Route path="template-insights" element={<TemplateInsightsPage />} /> */}
      <Route path="reports/:reportId" element={<ReportViewerPage />} />
    </Routes>
  );
}
